import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PagingControl } from '../../../../components/paging-control';
import Global from '../../../../store/global-selectors';
import { getFreightGridRequest } from '../../../../store/ltl/grid/ltl.grid.actions';
import { calculatePagingStats } from '../../../../services/pagination-service';

export const FreightPagingControl = () => {
  const dispatch = useDispatch();
  const page = useSelector(Global.selectLtlGridPage);
  const pageSize = useSelector(Global.selectLtlGridPageSize);
  const totalRecords = useSelector(Global.selectLtlGridTotalRecords);
  const totalPages = useSelector(Global.selectLtlGridTotalPages);

  const { viewStartingCount, viewEndingCount } = useMemo(
    () => calculatePagingStats(page, pageSize, totalRecords),
    [page, pageSize, totalRecords],
  );

  const handlePageChange = useCallback(
    (newPage: number, newPageSize: number) => {
      dispatch(getFreightGridRequest(newPage, newPageSize));
    },
    [dispatch],
  );

  return (
    <PagingControl
      onPageChange={handlePageChange}
      page={page}
      pageSize={pageSize}
      totalPages={totalPages}
      totalRecords={totalRecords}
      viewEndingCount={viewEndingCount}
      viewStartingCount={viewStartingCount}
    />
  );
};
